import {
    PRODUCTS_REQUEST,
    PRODUCTS_REQUEST_SUCCESS,
    PRODUCTS_REQUEST_FAIL
} from './index'
import api from '../utils/axiosInstance'
import { getallproducts } from '../constant/routes'

export const getallProducts = (page = 1, limit = 10) => async (dispatch) => {
    dispatch({
        type: PRODUCTS_REQUEST,
    });
    const productsData = await api.get(`${getallproducts}?page=${page}&limit=${limit}`)
    .then(res => res)
    .catch(error => error);

    if(productsData.status === 200){
        dispatch({
            type : PRODUCTS_REQUEST_SUCCESS,
            payload: { ...productsData.data, page },
        });
    } else {
        dispatch({
            type: PRODUCTS_REQUEST_FAIL,
            payload: productsData.data,
        });
    };
}